// extracted by mini-css-extract-plugin
module.exports = {"audit":"audit--1N6Ye","btns":"btns--1BloD","saveBtn":"saveBtn--6E-gr","boxTitle":"boxTitle--3vJUf","info":"info--HCmJm","high":"high--1a7Rx","editor":"editor--13Xpw"};